import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { WITHDRAWALS_HISTORY_PERMISSIONS } from '@modules/withdrawals-history/constants';

import type {
  IWithdrawalsHistoryItem,
} from '../types';
import {
  WITHDRAWALS_HISTORY_ITEM_QUERY_KEY,
  WITHDRAWALS_HISTORY_ITEM_URL,
} from '../constants';

export default function useWithdrawalsHistoryItemQuery(
  id: Ref<number>,
): IContextQueryResult<IWithdrawalsHistoryItem[], Error, IWithdrawalsHistoryItem | undefined> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IWithdrawalsHistoryItem[], Error, IWithdrawalsHistoryItem | undefined>({
    queryKey: [WITHDRAWALS_HISTORY_ITEM_QUERY_KEY, id],
    queryFn: async ({ signal }) => fetchGet<IWithdrawalsHistoryItem[]>(
      WITHDRAWALS_HISTORY_ITEM_URL,
      {
        signal,
        permission: WITHDRAWALS_HISTORY_PERMISSIONS.SHOW,
        urlParams: {
          id: id.value,
        },
      },
    ),
    select: (data) => data[0],
    enabled: computed(() => !!id.value),
  });
}
